<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Placement en veille</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-duration">
                    <mat-label>Mode de mise en veille</mat-label>
                    <mat-select (selectionChange)="standByModeChange($event.value)" [value]="standByMode" matTooltip="Sélection du mode">
                        <mat-option [value]="StandByModes.Duration">Durée</mat-option>
                        <mat-option [value]="StandByModes.EndDate">Date de fin</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-duration">
                    <mat-label>Durée de placement en veille*</mat-label>
                    <input type="text" matInput [formControl]="durationFormControl" autocomplete="off" required (focusout)="onDurationChange($event.target.value)" />
                    @if (durationFormControl.hasError('required') && (durationFormControl?.dirty || durationFormControl?.touched)) {
                        <mat-error>La durée de placement en veille est obligatoire</mat-error>
                    }
                    @if (durationFormControl.hasError('pattern') && (durationFormControl?.dirty || durationFormControl?.touched)) {
                        <mat-error data-input-unitPrice-error>La durée de placement en veille est incorrecte</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-duration">
                    <mat-label>Date de sortie de la veille*</mat-label>
                    <input
                        matInput
                        [formControl]="endDateFormControl"
                        [ngxMatDatetimePicker]="picker"
                        autocomplete="off"
                        required
                        (dateChange)="onDateChange($event)"
                        (focusout)="onDateChange($event.target.value)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
                    @if (endDateFormControl.hasError('required') && (endDateFormControl?.dirty || endDateFormControl?.touched)) {
                        <mat-error>La date de sortie de la veille est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="validate()" [disabled]="!isValid">Valider</button>
    </mat-card-actions>
</mat-card>
